import {
  SelectorOptions
} from 'mage-deps/@klarna/bubble-ui'
import { components as coreComponents } from 'mage-core'
import { Modal } from 'mage-deps/@klarna/mp-ui'
import { selectors as i18nSelectors } from 'mage-i18n'
import { selectors as stateSelectors, thunks as stateThunks } from 'mage-state'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React from 'react'
import { connect } from 'react-redux'

const languageToOption = translatorFactory => language => ({
  value: language,
  id: `app-language-option-${language}`,
  // use the factory so we can display the language name in its own language
  label: translatorFactory(language)(`core.languages.${language}`)
})

const SelectLanguage = ({
  t,
  translatorFactory,
  language,
  languages,
  saveLanguage,
  onClose,
  userId
}) => {
  const languageOptionsSortedByLabel = languages
    .map(languageToOption(translatorFactory))
    .filter(str => str.label && str.label !== '')
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <Modal
      id='select-language'
      onClose={onClose}
      title={t('core.selectLanguage.title')}
      description={t('core.selectLanguage.paragraph')}
      buttonPrimary={{
        id: 'select-language-button',
        onClick: onClose,
        text: t('core.selectLanguage.submit')
      }}
    >
      <SelectorOptions
        options={languageOptionsSortedByLabel}
        defaultValue={language}
        onSelect={language => saveLanguage(userId, language)}
      />
    </Modal>
  )
}

SelectLanguage.propTypes = {
  t: PropTypes.func.isRequired,
  translatorFactory: PropTypes.func.isRequired,
  language: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveLanguage: PropTypes.func,
  onClose: PropTypes.func,
  userId: PropTypes.string
}

export default R.compose(
  coreComponents.withTokenHelper(tokenHelper => ({
    userId: tokenHelper.getUserId()
  })),
  connect(
    state => ({
      t: i18nSelectors.translator(state),
      translatorFactory: i18nSelectors.translatorFactory(state),
      language: i18nSelectors.language(state),
      languages: stateSelectors.getLanguages(state)
    }),
    {
      saveLanguage: stateThunks.saveLanguage
    }
  )
)(SelectLanguage)

export { SelectLanguage }
